var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2129_2727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0747 0C15.1254 0 15.1761 0 15.2296 0C15.3539 1.53548 14.7678 2.68278 14.0555 3.51362C13.3566 4.33873 12.3996 5.13897 10.8517 5.01755C10.7484 3.50406 11.3355 2.44185 12.0468 1.61292C12.7065 0.840402 13.9159 0.152974 15.0747 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7605 15.9836C19.7605 15.9989 19.7605 16.0123 19.7605 16.0266C19.3255 17.3441 18.705 18.4732 17.9478 19.5211C17.2565 20.4724 16.4094 21.7526 14.8969 21.7526C13.5899 21.7526 12.7218 20.9122 11.3823 20.8893C9.96538 20.8663 9.18616 21.592 7.89067 21.7746C7.74247 21.7746 7.59428 21.7746 7.44895 21.7746C6.49764 21.6369 5.72991 20.8835 5.17059 20.2047C3.52134 18.1988 2.24688 15.6078 2.00977 12.2921C2.00977 11.967 2.00977 11.6429 2.00977 11.3179C2.11015 8.94485 3.2632 7.01546 4.79581 6.08041C5.60466 5.58324 6.71659 5.15969 7.95472 5.349C8.48535 5.43122 9.02745 5.61288 9.50263 5.79262C9.95295 5.96568 10.5161 6.27258 11.0496 6.25633C11.411 6.24581 11.7705 6.05746 12.1347 5.92456C13.2017 5.53926 14.2477 5.09755 15.6264 5.30502C17.2833 5.55551 18.4593 6.2917 19.1859 7.42753C17.7843 8.31956 16.6762 9.66383 16.8655 11.9594C17.0337 14.0446 18.2461 15.2646 19.7605 15.9836Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2129_2727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.773,
    height: 21.773,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.5d0f11fd6387601400a54d11576d7a90.svg";
export { ForwardRef as ReactComponent };